import React, { useContext } from 'react';
import classnames from 'classnames';
import DeviationDuperbrowseContext from '../../../Duperbrowse/DeviationDuperbrowseContext';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import SidebarBlock from '../SidebarBlock';
import ThumbWithLoader from '../ThumbWithLoader';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import ContainerSize from '../../../ContainerSize';
import s from './TextualThumbBlock.scss';
var defaultThumbHeight = parseInt(s['sidebar-thumb-height-default'], 10);
var shopThumbHeight = parseInt(s['sidebar-thumb-height-shop'], 10);
var thumbWidth = parseInt(s['sidebar-thumb-width'], 10);
var TextualThumbBlock = function (_a) {
    var _b = _a.deviations, deviations = _b === void 0 ? [] : _b, streamKey = _a.streamKey, titleOverride = _a.titleOverride, _c = _a.isLoading, isLoading = _c === void 0 ? false : _c, _d = _a.maxLength, maxLength = _d === void 0 ? 3 : _d, parentDeviation = _a.parentDeviation, useShop = _a.useShopThumb;
    var isMobile = useContext(MobileContext);
    if (!isLoading && !deviations.length) {
        return null;
    }
    var slice = isLoading
        ? Array(maxLength).fill(undefined)
        : deviations.slice(0, maxLength);
    return (React.createElement(SidebarBlock, { streamKey: streamKey, titleOverride: titleOverride, isLoading: isLoading },
        React.createElement(DeviationDuperbrowseContext, { streamId: "deviation-sidebar-" + streamKey + "-" + parentDeviation.deviationId, deviations: deviations, parent: {
                typeId: getDeviationResourceType(parentDeviation),
                itemId: parentDeviation.deviationId,
            } }, slice.map(function (deviation, index) { return (React.createElement(BiLoggerContextProvider, { key: index, value: { _rankIndex: index } },
            React.createElement(ContainerSize, { className: s['measured-container'] }, function (_a) {
                var containerWidth = _a.containerWidth, containerHeight = _a.containerHeight;
                return (React.createElement(ThumbWithLoader, { deviation: deviation, isLoading: isLoading, className: classnames(s['thumb'], useShop && s['shop']), height: useShop ? shopThumbHeight : defaultThumbHeight, width: isMobile ? containerWidth : thumbWidth, useShopThumb: useShop }));
            }))); }))));
};
TextualThumbBlock.displayName = 'TextualThumbBlock';
export default TextualThumbBlock;
//# sourceMappingURL=TextualThumbBlock.js.map